import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-6811b4af"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "text-fa"
};
const _hoisted_2 = {
  class: "text-title"
};
const _hoisted_3 = {
  class: "title-tips"
};
const _hoisted_4 = {
  class: "text-cont-fa"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LaborDetailTitleValue = _resolveComponent("LaborDetailTitleValue");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString($props.moudleName), 1)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_LaborDetailTitleValue, {
    title: "有效链接",
    value: $props.laboratoryItemDetail.net_link || '-'
  }, null, 8, ["value"]), _createVNode(_component_LaborDetailTitleValue, {
    title: "网络条件要求",
    value: $props.laboratoryItemDetail.net_require || '-'
  }, null, 8, ["value"]), _createVNode(_component_LaborDetailTitleValue, {
    title: "用户操作系统",
    value: $props.laboratoryItemDetail.net_os || '-'
  }, null, 8, ["value"]), _createVNode(_component_LaborDetailTitleValue, {
    title: "用户非操作系统软件配置要求",
    value: $props.laboratoryItemDetail.net_software_require || '-'
  }, null, 8, ["value"]), _createVNode(_component_LaborDetailTitleValue, {
    title: "用户硬件配置要求",
    value: $props.laboratoryItemDetail.net_hardware_require || ''
  }, null, 8, ["value"]), _createVNode(_component_LaborDetailTitleValue, {
    title: "用户特殊外置硬件要求",
    value: $props.laboratoryItemDetail.net_hardware_other_require || '-'
  }, null, 8, ["value"]), _createVNode(_component_LaborDetailTitleValue, {
    title: "网络安全",
    value: $props.laboratoryItemDetail.net_safe || '-'
  }, null, 8, ["value"])])]);
}